<template>
	<div class="">
		<div class="grid grid-cols-12 gap-6 mt-8">
			<div class="col-span-12">
				<!-- BEGIN: Inbox Filter -->
				<div class="intro-y flex flex-col-reverse sm:flex-row items-center">
					<div class="w-full sm:w-auto relative mr-auto mt-3 sm:mt-0">
						<SearchIcon class="w-4 h-4 absolute my-auto inset-y-0 ml-3 left-0 z-10 text-gray-700 dark:text-gray-300" />
						<input type="text" v-model="searchTerm" class="input w-full sm:w-64 box px-10 text-gray-700 dark:text-gray-300 placeholder-theme-13" placeholder="Buscar..." />
					</div>
				</div>
				<!-- END: Inbox Filter -->
				<!-- BEGIN: Inbox Content -->
				<div class="intro-y inbox box mt-5">
					<notificaciones-list :opciones="true" :searchTerm="searchTerm"></notificaciones-list>
				</div>
				<!-- END: Inbox Content -->
			</div>
		</div>

	</div>
</template>
<script>
	import Modal from "@/global-components/Modal";
	import NotificacionesList from "@/components/NotificacionesList";
	
	export default {
		components: {
			Modal,
			NotificacionesList
		},
		data() {
			return {
				searchTerm:""
			}
		},
		methods: {
		}
	};

</script>